import React, { useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import './Register.css'

const initialFormState = {
    nombre: '',
    email: '',
    telefono: '',
    direccion: '',
    rol: 'cliente',
};

export default function Register({ onSuccess }) {
    const [form, setForm] = useState(initialFormState);
    const [mensaje2, setMensaje2] = useState('');
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const updateField = (field, value) => {
        setForm((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const crearCatalogo = async (e) => {
        e.preventDefault();
        setMensaje2('Procesando...')
        try {
            const formData = new FormData();
            formData.append('nombre', form.nombre);
            formData.append('email', form.email);
            formData.append('telefono', form.telefono);
            formData.append('direccion', form.direccion);
            formData.append('rol', form.rol);
            formData.append('sendActivation', '1');

            const response = await fetch(`${baseURL}/registroPost.php`, {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                if (data.mensaje) {
                    toast.success(data.mensaje);
                    setMensaje2('')
                    setForm(initialFormState);
                    setModalOpen(false);
                    if (typeof onSuccess === 'function') {
                        onSuccess();
                    }

                } else if (data.error) {
                    toast.error(data.error);
                    setMensaje2('')

                }
            } else {
                throw new Error('Error en la solicitud al servidor');
            }
        } catch (error) {
            console.error('Error:', error.message);
            toast.error(error.message);
            setMensaje2('')
        }
    };

    return (
        <div >
            <button onClick={toggleModal} className='btnSave'>
                <span>  +</span>   Agregar
            </button>
            {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Usuario</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form onSubmit={crearCatalogo} id='crearForm'>

                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input
                                        type="text"
                                        id="nombre"
                                        name="nombre"
                                        value={form.nombre}
                                        onChange={(e) => updateField('nombre', e.target.value)}
                                        required
                                        placeholder="Nombre"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Email</legend>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={form.email}
                                        onChange={(e) => updateField('email', e.target.value)}
                                        required
                                        placeholder="Email"
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Telefono</legend>
                                    <input
                                        type="text"
                                        id="telefono"
                                        name="telefono"
                                        value={form.telefono}
                                        onChange={(e) => updateField('telefono', e.target.value)}
                                        placeholder="Telefono"
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Direccion</legend>
                                    <input
                                        type="text"
                                        id="direccion"
                                        name="direccion"
                                        value={form.direccion}
                                        onChange={(e) => updateField('direccion', e.target.value)}
                                        placeholder="Direccion"
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Rol</legend>
                                    <select
                                        id="rol"
                                        name="rol"
                                        value={form.rol}
                                        onChange={(e) => updateField('rol', e.target.value)}
                                        required
                                    >
                                        <option value="cliente">Cliente</option>
                                        <option value="admin">Admin</option>
                                    </select>
                                </fieldset>

                                <p className='helperText'>
                                    El usuario recibira un correo para activar su cuenta y crear su propia clave.
                                </p>

                            </div>
                            {mensaje2 ? (
                                <button type="button" className='btnLoading' disabled>
                                    {mensaje2}
                                </button>
                            ) : (
                                <button type="submit" className='btnPost'>
                                    Agregar
                                </button>
                            )}

                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
